export enum TaxDocumentStatus {
    Complete = "COMPLETE",
    AwaitingDocuments = "AWAITING_DOCUMENTS",
    NotRequired = "NOT_REQUIRED",
    AwaitingSignature = 'AWAITING_SIGNATURE',
    Error = "ERROR",
}

